
/**
 * Your Components
 */
import VeeValidate from "vee-validate";
import VueMatchHeights from "vue-match-heights";
import Toasted from "vue-toasted";
import numeral from "numeral";

// import SocialShareButton from "./social/SocialShareButton";
// import ProductSearch from "./product-search/ProductSearch";
// import ProductView from "./product/ProductView";
// import CartQtyInput from "./cart/CartQtyInput";
// import ItemCountComponent from "./cart/ItemCountComponent";
// import CheckoutStatus from "./checkout/CheckoutStatus";
// import BlogList from "./blog/BlogList";
// import CartPreviewDropdown from "./cart/CartPreviewDropdown";
// import MovieList from "./movies/MovieList";
// import GetLocation from "./movies/GetLocation";

// import Countries from "./movies/Country";
// import NewMovies from "./movies/NewMovies";
// import MovieItem from "./movies/MovieItem";
// import SelectedMovie from "./movies/SelectedMovie";
// import MovielistItem from "./movies/MovielistItem";
// import BannerLink from "./movies/BannerLink";
import VModal from 'vue-js-modal'
import Vue from "vue";

// ecommerce
// Vue.component("product-search",  () => import('./product-search/ProductSearch') );
// Vue.component("product-view",  () => import('./product/ProductView') );
// Vue.component("cart-qty-input",  () => import('./cart/CartQtyInput') );
// Vue.component("itemcount-component",  () => import('./cart/ItemCountComponent') );
// Vue.component("checkout-status",  () => import('./checkout/CheckoutStatus') );
// Vue.component("cart-preview-dropdown",  () => import('./cart/CartPreviewDropdown') );

Vue.component("social-share-button",  () => import('./social/SocialShareButton') );
Vue.component("blog-list",  () => import('./blog/BlogList') );
Vue.component("movie-list", () => import('./movies/MovieList') );
Vue.component("get-location", () => import('./movies/GetLocation') );
Vue.component("country-list", () => import('./movies/Country') );
Vue.component("movie-item", () => import('./movies/MovieItem') );
Vue.component("new-movies", () => import('./movies/NewMovies') );
Vue.component("selected-movie", () => import('./movies/SelectedMovie') );
Vue.component("movielist-item", () => import('./movies/MovielistItem') );
Vue.component("banner-link", () => import('./movies/BannerLink') );



/**
 * External Components. eg. Packages
 */
Vue.use(VeeValidate);

Vue.use(VueMatchHeights, {});

Vue.use(VModal,
  {
    dialog: true,
    dynamicDefaults: {
      draggable: true
    }
});

Vue.use(Toasted, {
  theme: "outline",
  duration: 2000,
  action: [
    {
      text: "close",
      onClick: (e, toastObject) => {
        toastObject.goAway(0);
      }
    }
  ],
  iconPack: "fontawesome"
});

Vue.filter("priceFormat", function(value) {
  return numeral(value).format("0,0.00");
});

Vue.filter("moneyToCurrencyFormat", function({ amount, currency }) {
  return currency + " " + numeral(amount / 100).format("0,0.00");
});

Vue.filter("moneyToDecimal", function({ amount }) {
  return parseFloat(amount / 100);
});
